import routes from 'actions/routes';
import { generateCreateActionCreator, generateReadOneActionCreator, generateUpdateActionCreator, generateDeleteActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    getAttachments: generateReadOneActionCreator(routes.API_TEXT_TEMPLATES, ACTION_NAMES.TEXT_ATTACHMENTS, 'text_attachment'),
    createAttachments: generateCreateActionCreator(routes.API_TEXT_TEMPLATES, ACTION_NAMES.TEXT_ATTACHMENTS, () => {}, () => {}, 'text_attachment'),
    updateAttachment: generateUpdateActionCreator(routes.API_TEXT_ATTACHMENTS, ACTION_NAMES.TEXT_ATTACHMENTS),
    deleteAttachment: generateDeleteActionCreator(routes.API_TEXT_ATTACHMENTS, ACTION_NAMES.TEXT_ATTACHMENTS)
}
